import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import './styles.scss';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import PlanGapSVGR from '../../../../../../assets/svgr/PlanGapSVGR';
import { useAppContext } from '../../../../../../context/appContext';
import ACTIONS from '../../../../../../context/appActions';
import { DOWNLOAD_BROCHURE_URL } from '../../../../../../constants';
import { openUrl } from '../../../../../../utils';
import PlanGapMobileSVGR from '../../../../../../assets/svgr/PlanGapMobileSVGR';

const PlanGap = () => {
  /* eslint-disable */
  const [tempErrorDialogShow, setTempErrorDialogShow] = useState(false);
  const { dispatch } = useAppContext();
  const execute = () => {
    dispatch({ type: ACTIONS.UPDATE_STATE, data: { hasError: !tempErrorDialogShow } });
  };
  /* eslint-enable */

  const tabletScreen = useMediaQuery((theme) => theme.breakpoints.up('customtablet'));

  return (
    <Container>
      <Grid container className='plan-gap-container' sx={{ pl: { laptop: 10 }, pr: { lg: 10 } }}>
        <Grid className='responsive-center' item xs={12} laptop={4} sx={{ mt: { xs: 4, laptop: -3 } }}>
          {tabletScreen ? <PlanGapSVGR /> : <PlanGapMobileSVGR /> }
        </Grid>
        <Grid item sm={12} laptop={8}>
          <Box sx={{ mt: { xs: 2, laptop: 8 } }}>
            <Typography className='plan-gap description' variant='span'>
              Download the
              {' '}
            </Typography>
            <Typography className='plan-gap description-bold' variant='span'>
              The PlanGap Benefit Brochure
              {' '}
            </Typography>
            <Typography className='plan-gap description' variant='span'>
              and contact your financial professional today.
            </Typography>
          </Box>
          <Box className='responsive-center' mt={4} mb={4} sx={{ ml: { laptop: 15, lg: 8 } }}>
            <Button variant='contained' className='primary-btn download-brochure' onClick={() => openUrl(DOWNLOAD_BROCHURE_URL, '_blank')}>
              Download Brochure
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default PlanGap;
